import AppImage from '@/components/ui/AppImage';
import homepageTranslations from '@/lib/homepageTranslations.json';

interface BrandStorySectionProps {
  currentLang?: 'sl' | 'en';
}

export default function BrandStorySection({ currentLang = 'sl' }: BrandStorySectionProps) {
  const lang = currentLang === 'en' ? 'en' : 'sl';
  const content = {
    label: homepageTranslations.brandStory.label[lang],
    title: homepageTranslations.brandStory.title[lang],
    text1: homepageTranslations.brandStory.text1[lang],
    text2: homepageTranslations.brandStory.text2[lang],
    text3: homepageTranslations.brandStory.text3[lang],
    accessibility: homepageTranslations.brandStory.accessibility[lang],
    quote: homepageTranslations.brandStory.quote[lang],
  };

  return (
    <section id="about" className="py-32 px-6 md:px-10 max-w-7xl mx-auto">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        {/* Text Content */}
        <div className="space-y-8">
          <p className="text-xs font-bold uppercase tracking-[0.4em] text-muted-foreground">
            {content.label}
          </p>
          <h2 className="text-5xl md:text-6xl font-bold tracking-tighter leading-none">
            {content.title}
          </h2>
          <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
            <p>{content.text1}</p>
            <p>{content.text2}</p>
            <p>{content.text3}</p>
            <p>{content.accessibility}</p>
          </div>
          <blockquote className="text-base md:text-lg italic border-l-2 border-primary pl-4">
            {content.quote}
          </blockquote>
        </div>

        {/* Image Gallery */}
        <div className="space-y-6">
          <div className="aspect-[16/10] card-rounded overflow-hidden">
            <AppImage
              src="/images/cebelnjak.webp"
              alt="Rows of wooden beehives in sunny meadow with mountains in background"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
            />
          </div>
          <div className="aspect-video card-rounded overflow-hidden">
            <AppImage
              src="https://images.unsplash.com/photo-1702495464926-0085637df194"
              alt="Close-up of beekeeper hands holding honeycomb frame covered with bees"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
